import React, { useEffect, useState } from "react";
import {
  EmptyImg,
  EnterpriseList,
  ImageContainer,
  MainContainer,
} from "./styles";
import TopBar from "./components/TopBar";
import Card from "./components/Card";
import Button from "../../components/Button";
import ThemeColors from "../../themes/colors";
import { Row } from "../../themes/globalStyle";
import Typography from "../../components/Typography";
import { FaCirclePlus } from "react-icons/fa6";
import { enterpriseService } from "../../services/modules/enterprise";
import { EnterpriseResponse } from "../../types/enterprise";
import { Result } from "antd";
import Empty from "../../assets/svg/empty.svg";
import EnterpriseModal from "./components/EnterpriseModal";

const Enterprises: React.FC = (): JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [enterprises, setEnterprises] = useState<EnterpriseResponse[]>();

  const fetchEnterprises = () => {
    enterpriseService
      .getEnterprises()
      .then((response) => setEnterprises(response));
  };

  useEffect(() => {
    fetchEnterprises();
  }, []);

  return (
    <MainContainer>
      <TopBar />
      <Row style={{ padding: "0 2rem" }}>
        <Button
          size="large"
          borderRadius="0.5rem"
          style={{ width: "fit-content" }}
          backgroundColor={ThemeColors.Gradient100}
          onClick={() => setIsModalOpen(true)}
        >
          <Row>
            <FaCirclePlus color="Bg300" />
            <Typography
              text="Adicionar nova empresa"
              size="medium"
              color="Bg300"
              weight={400}
            />
          </Row>
        </Button>
      </Row>
      {enterprises ? (
        <>
          {enterprises.length === 0 ? (
            <ImageContainer>
              <Result
                icon={<EmptyImg src={Empty} />}
                title="Você ainda não tem nenhuma empresa cadastrada"
                subTitle="Para começar, clique no botão 'Adicionar nova empresa' e comece a explorar todas as possibilidades que a plataforma CoProdux tem para te oferecer!"
              />
            </ImageContainer>
          ) : (
            <EnterpriseList>
              {enterprises.map((enterprise) => (
                <Card
                  key={enterprise._id}
                  id={enterprise._id}
                  title={enterprise.company_name}
                  url={enterprise.website}
                  avatar={enterprise.avatar}
                />
              ))}
            </EnterpriseList>
          )}
        </>
      ) : (
        <ImageContainer>
          <Result
            icon={<EmptyImg src={Empty} />}
            title="Oops!"
            subTitle="Você não possui nenhuma empresa cadastrada."
          />
        </ImageContainer>
      )}
      <EnterpriseModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        onCreate={() => {
          setIsModalOpen(false);
          fetchEnterprises();
        }}
      />
    </MainContainer>
  );
};

export default Enterprises;
